import { UserAdapter } from '@core/adapters';
import { SignUpOAuthPayload, SignUpOAuthResponse } from '@core/dto';

export class SignUpOAuthUsecase {
  constructor(private readonly UserAdapter: UserAdapter) {
    this.UserAdapter = UserAdapter;
  }

  async execute(payload: SignUpOAuthPayload): Promise<SignUpOAuthResponse> {
    return await this.UserAdapter.signUpOAuth(payload);
  }
}
